<template>
    <router-view />
</template>

<script>
export default {
    name: 'AssistedPage',
};
</script>
